// ═══ 말소 셸 데스크톱(≥1024) 회사명 드롭다운 — WhoMenu 마크업 복제, 행만 말소 셸용 ═══
// 행 = 수거 주소 · 언어 · 이용 안내 · (대표) 오토덱스 전체 기능으로 전환 · 오류 신고 · 로그아웃. 모바일은 screens/MalsoMore.js.
// 동작은 moreActions.js(전환)·simple/moreActions.js(로그아웃) 공용. 언어 서버 저장은 셸 effect 담당 — 여기서 호출 금지.
// props: { user, onLogout, showToast }
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { T, R } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { openBugReport } from '../../../components/BugReportButton';
import { canOfferMalso } from '../../simple/screenMode';
import ConfirmSheet from '../../simple/parts/ConfirmSheet';
import Glyph from '../../simple/parts/Glyph';
import LangSelect from '../../simple/parts/LangSelect';
import LtrText from '../../simple/parts/LtrText';
import { initialsOf } from '../../simple/parts/WhoMenu';
import { logoutSimple } from '../../simple/moreActions';
import { switchToFull } from '../moreActions';
import PickupAddressSheet from './PickupAddressSheet';

var menu = { position: 'absolute', top: 'calc(100% + 8px)', insetInlineEnd: 0, width: 290, minWidth: 260, zIndex: 70,
  background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, boxShadow: T.shadowMenu,
  overflow: 'clip', color: T.ink, textAlign: 'start' };
var head = { display: 'flex', alignItems: 'center', gap: 9, padding: '11px 14px',
  borderBottom: '1px solid ' + T.bdSoft, background: T.head, minWidth: 0 };
var headAv = { width: 30, height: 30, borderRadius: R.md, flex: 'none', display: 'grid', placeItems: 'center',
  direction: 'ltr', background: 'linear-gradient(135deg,' + T.navy + ',' + T.accent + ')', color: T.card,
  fontSize: 11, fontWeight: 800 };
var headTx = { minWidth: 0 };
var headName = { display: 'block', fontSize: 12.5, fontWeight: 800, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var headSub = { display: 'block', fontSize: 11, color: T.faint, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
// border 는 단축만 — 변형끼리 키 집합이 같아야 React 가 스타일을 지우지 않는다(theme.js 주석 규칙).
var row = { display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 14px',
  border: 0, borderBottom: '1px solid ' + T.bdSoft, fontSize: 12.5, color: T.body, background: 'none',
  textAlign: 'start', fontFamily: 'inherit', minWidth: 0 };
var rowBtn = Object.assign({}, row, { cursor: 'pointer' });
var rowLast = Object.assign({}, row, { cursor: 'pointer', borderBottom: 0 });
var glyph = { color: T.muted, flex: 'none', display: 'flex' };
var tx = { flex: 1, minWidth: 0 };
var t1 = { display: 'block', fontSize: 12.5, fontWeight: 700, color: T.ink, whiteSpace: 'normal', lineHeight: 1.35 };
var t2 = { display: 'block', fontSize: 11, color: T.faint, marginTop: 1, whiteSpace: 'normal', lineHeight: 1.35 };
var right = { marginInlineStart: 'auto', display: 'flex', alignItems: 'center', gap: 6, flex: 'none' };

function Chevron() {
  return (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M5.5 9l6.5 6.5L18.5 9" /></svg>);
}

function MalsoWhoMenu(props) {
  var t = useT();
  var navigate = useNavigate();
  var user = props.user || {};
  var st = useState(false);
  var open = st[0], setOpen = st[1];
  var st2 = useState('');
  var sheet = st2[0], setSheet = st2[1];
  var boxRef = useRef(null);

  var companyName = user.companyNameEn || user.companyName || user.name || '';

  // 바깥 클릭·ESC 로 닫힘 — 열려 있을 때만 건다.
  useEffect(function () {
    if (!open) return undefined;
    var onDown = function (e) {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    var onKey = function (e) { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return function () {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
    // setOpen 은 useState 가 보장하는 안정 참조 — 배열 구조분해라 린터가 못 알아본다.
  }, [open, setOpen]);

  var goFull = function () { setSheet(''); switchToFull(navigate, props.showToast, t); };
  var doLogout = function () { setSheet(''); logoutSimple(props.onLogout, navigate); };
  var pick = function (name) { setOpen(false); setSheet(name); };

  return (<div className="ss-whowrap" ref={boxRef}>
    <button type="button" className={'ss-who ss-who-btn' + (open ? ' on' : '')} data-testid="ss-who-btn"
      aria-haspopup="true" aria-expanded={open ? 'true' : 'false'}
      onClick={function () { setOpen(!open); }}>
      <span className="ss-av">{initialsOf(companyName)}</span>
      <span dir="ltr" className="ss-who-name">{companyName}</span>
      <Chevron />
    </button>

    {open ? (<div className="ss-menu" role="menu" style={menu}>
      <div style={head}>
        <span style={headAv}>{initialsOf(companyName)}</span>
        <span style={headTx}>
          <LtrText style={headName}>{companyName}</LtrText>
          <LtrText style={headSub}>{user.name || ''}</LtrText>
        </span>
      </div>

      <button type="button" className="ss-mrow" style={rowBtn} data-testid="malso-menu-pickup" onClick={function () { pick('pickup'); }}>
        <span style={glyph}><Glyph id="pin" /></span>
        <span style={tx}><span style={t1}>{t('carCancelPickupSection')}</span></span>
      </button>

      <div className="ss-mrow" style={row}>
        <span style={glyph}><Glyph id="translate" /></span>
        <span style={tx}><span style={t1}>{t('settingsLanguage')}</span></span>
        <span style={right}><LangSelect variant="row" /></span>
      </div>

      <button type="button" className="ss-mrow" style={rowBtn} data-testid="malso-menu-guide"
        onClick={function () { setOpen(false); navigate('/main/m/guide'); }}>
        <span style={glyph}><Glyph id="help" /></span>
        <span style={tx}><span style={t1}>{t('malsoModeGuideTitle')}</span></span>
      </button>

      {canOfferMalso(user) ? (<button type="button" className="ss-mrow" style={rowBtn} data-testid="malso-menu-full"
        onClick={function () { pick('full'); }}>
        <span style={glyph}><Glyph id="apps" /></span>
        <span style={tx}>
          <span style={t1}>{t('malsoModeSwitchToFull')}</span>
          <span style={t2}>{t('simpleShowAllSub')}</span>
        </span>
      </button>) : null}

      <button type="button" className="ss-mrow" style={rowBtn} data-testid="malso-menu-bug"
        onClick={function () { setOpen(false); openBugReport('form'); }}>
        <span style={glyph}><Glyph id="bug" /></span>
        <span style={tx}><span style={t1}>{t('moreBugReport')}</span></span>
      </button>

      <button type="button" className="ss-mrow" style={Object.assign({}, rowLast, { color: T.danger })}
        onClick={function () { pick('logout'); }}>
        <span style={Object.assign({}, glyph, { color: T.danger })}><Glyph id="power" /></span>
        <span style={tx}><span style={Object.assign({}, t1, { color: T.danger })}>{t('settingsProfileLogout')}</span></span>
      </button>
    </div>) : null}

    {sheet === 'pickup' ? <PickupAddressSheet user={user} showToast={props.showToast} onClose={function () { setSheet(''); }} /> : null}
    <ConfirmSheet open={sheet === 'full'} title={t('malsoModeSheetToFullTitle')} sub={t('malsoModeSheetToFullBody')}
      hint={t('malsoModeSheetToFullHint')} confirmLabel={t('malsoModeSwitchToFull')} onConfirm={goFull}
      onClose={function () { setSheet(''); }} />
    <ConfirmSheet open={sheet === 'logout'} title={t('settingsProfileLogout')} sub={t('settingsProfileLogoutConfirmMessage')}
      confirmLabel={t('settingsProfileLogout')} onConfirm={doLogout} onClose={function () { setSheet(''); }} />
  </div>);
}

export default MalsoWhoMenu;
